<template>
  <v-layout>
    <v-flex xs12 sm6 offset-sm1>
      <v-text-field v-model="jobName" label="Werkzaamheid" required></v-text-field>
      <v-list>
        <v-list-tile v-for="job in jobs" v-bind:key="job.id" class="listitem">
          <v-list-tile-content>{{ job.name }}</v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-flex>
    <v-flex>
      <v-btn color="primary" @click="save">opslaan</v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import { configurationService } from "@/services/admin";

export default {
  name: "job-add-form",
  data: () => ({
    jobName: null,
    jobs: []
  }),
  methods: {
    resolveJobs() {
      configurationService.listJobs().then(result => {
        this.jobs = result.data;
      });
    },
    save() {
      // eslint-disable-next-line no-unused-vars
      configurationService.createJob(this.jobName).then(result => {
            this.jobName = null;
            this.resolveJobs();
          }
      );
    }
  },
  created() {
    this.resolveJobs();
  }
}
</script>
